import { routes } from "../../assets/constants";
import { ApiMethod } from "../models/api-types.type";
import { useApi } from "./use-api.hook";

export interface InvitationPreview {
    delivery: "email" | "link";
    email?: string;
    role: string;
    vendorName?: string;
    expiresAt: string;
}

/**
 * The account pages anyone can reach without signing in: accepting an
 * invitation, resetting a password, confirming an email. Tokens go in the
 * body, never the URL, so they stay out of server logs.
 */
export const useAccountApi = () => {
    const { sendRequest } = useApi();

    return {
        previewInvitation: (token: string): Promise<InvitationPreview> =>
            sendRequest(ApiMethod.POST, routes.invitations.preview, { token }),
        acceptInvitation: (body: { token: string; firstname: string; lastname: string; password: string; email?: string }): Promise<{ email: string; verified: boolean }> =>
            sendRequest(ApiMethod.POST, routes.invitations.accept, body),
        /** Join with Google: the account is made and signed in, so both tokens come back. */
        acceptInvitationWithGoogle: (body: { token: string; credential: string }): Promise<{ email: string; verified: boolean; access_token: string; refresh_token: string }> =>
            sendRequest(ApiMethod.POST, routes.invitations.acceptGoogle, body),
        forgotPassword: (email: string) =>
            sendRequest(ApiMethod.POST, routes.account.forgotPassword, { email }),
        checkPasswordReset: (token: string): Promise<{ email: string }> =>
            sendRequest(ApiMethod.POST, routes.account.checkPasswordReset, { token }),
        resetPassword: (token: string, password: string): Promise<{ email: string }> =>
            sendRequest(ApiMethod.POST, routes.account.resetPassword, { token, password }),
        verifyEmail: (token: string): Promise<{ email: string }> =>
            sendRequest(ApiMethod.POST, routes.account.verifyEmail, { token }),
        resendVerification: (email: string) =>
            sendRequest(ApiMethod.POST, routes.account.resendVerification, { email }),
    };
};
